
export default class BookingComment{

    constructor(data) {
        this.name = null;
        this.text = null;
        this.id= null;

        if (data) {
            Object.assign(this, data);
        }
    }

}



// WEBPACK FOOTER //
// ./src/modules/main/model/booking-comment.model.js